import type { Language } from "@templestay/i18n";

/**
 * 사용자 언어의 텍스트가 비어있으면(공백 포함) defaultLang으로 폴백.
 * 공백만 있는 값은 미입력으로 취급.
 */
export function resolveText(
  i18n: Record<Language, Record<string, string>>,
  lang: Language,
  defaultLang: Language
): Record<string, string> {
  const current = i18n[lang] ?? {};
  const fallback = lang !== defaultLang ? (i18n[defaultLang] ?? {}) : {};
  const lastResort = lang !== "ko" && defaultLang !== "ko" ? (i18n.ko ?? {}) : {};

  const allKeys = new Set([
    ...Object.keys(current),
    ...Object.keys(fallback),
    ...Object.keys(lastResort),
  ]);

  const result: Record<string, string> = {};
  for (const key of allKeys) {
    const val = (current[key] ?? "").trim();
    if (val) { result[key] = current[key]; continue; }
    const fallbackVal = (fallback[key] ?? "").trim();
    if (fallbackVal) { result[key] = fallback[key]; continue; }
    result[key] = lastResort[key] ?? "";
  }
  return result;
}

/**
 * name_i18n JSON에서 제목 텍스트를 가져옴. 폴백 포함.
 */
export function resolveTitle(
  nameI18nStr: string,
  lang: Language,
  defaultLang: Language,
  fallbackName: string
): string {
  try {
    const parsed = JSON.parse(nameI18nStr) as Record<Language, Record<string, string>>;
    const resolved = resolveText(parsed, lang, defaultLang);
    return (resolved.title ?? "").trim() || fallbackName;
  } catch {
    return fallbackName;
  }
}
